import { buildRoute } from '@direct-frontend/modules-router';

export const ordersRoute = buildRoute('/orders');
export const ordersImportExcelRoute = buildRoute('/orders/import/excel');
